import { mergeRatePlans } from "@/helpers/mergeRatePlans.ts";
import { RateGroup } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

/**
 * Updates cart items' rateGroup and ratePlan data with fresh translations from re-fetched rate groups.
 * Used when the language changes so that step 2+ shows correctly translated content.
 */
export const updateCartItemsTranslationsHelper = (state: EngineStoreData, freshRateGroups: RateGroup[]) => {
  const cartAccommodationItems = state.cartAccommodationItems.map((item) => {
    const freshRG = freshRateGroups.find((rg) => rg.id === item.rateGroup.id);
    if (!freshRG) return item;

    const freshMergedPlans = mergeRatePlans(freshRG);
    const freshRP = freshMergedPlans.find((rp) => rp.id === item.ratePlan.id);

    return {
      ...item,
      rateGroup: freshRG,
      ratePlan: freshRP ?? { ...item.ratePlan, rateGroup: freshRG },
    };
  });

  return { cartAccommodationItems };
};
